import React, { Component } from "react";
import { Row, Col, Icon, Tooltip } from "antd";

// service
import AppService from "../../app.service";

// model
import NoticeDetails from "../model/noticeDetails";
import NoticeItemModel from "../model/noticeItem";

// components
import NoticeDetailsModal from "./modal/noticeDetails";

// icon
import AnswerIcon from "@/assets/image/answer.svg";
import AttachmentIcon from "@/assets/image/atachment.svg";
import ReplayIcon from "@/assets/image/replay.svg";
import { DetailModal } from "./modal/DetailModal";

interface iProps {
  notice: NoticeItemModel;
  getNoticeList: () => void;
  displayWrap?: boolean;
}
interface iState {
  modalVisible: boolean;
  noticeDetails: NoticeDetails;
  readStatus: boolean;
  readBtnStatus: boolean;
}
export default class noticeItem extends Component<iProps, iState> {
  private appService: AppService = new AppService();
  state: iState = {
    modalVisible: false,
    noticeDetails: new NoticeDetails(),
    readStatus: false,
    readBtnStatus: false,
  };
  // 确认已读
  markNoticeRead = async () => {
    let data = await this.appService.markNoticeRead(this.props.notice.noticeId);
    return data;
  };
  // 点击查看详情
  checkNoticeDetails = async () => {
    if (
      !this.props.notice.needReplayFlag &&
      !this.props.notice.needAnswerFlag
    ) {
      let data = await this.markNoticeRead();
      if (data === "ok") {
        this.setState({ readStatus: true });
        this.getDetails();
      }
    } else {
      this.getDetails();
    }
  };
  // 获取详情
  getDetails = async () => {
    // let noticeDetails = await this.appService.getNoticeDetail(
    //   this.props.notice.noticeId
    // );
    // if (noticeDetails && typeof noticeDetails === "object") {
    //   this.setState({ noticeDetails });
    this.setState({ modalVisible: true });
    // }
  };
  // 已读回调
  readCallback = async () => {
    let data = await this.markNoticeRead();
    if (data === "ok") {
      await this.setState({ readStatus: true });
      await this.setState({ readBtnStatus: true });
      this.props.getNoticeList();
    }
  };
  // 回复回调
  answerCallback = async (answerContent: string) => {
    let data = await this.appService.answerNotice(
      this.props.notice.noticeId,
      answerContent
    );
    if (data === "ok") {
      await this.setState({ readStatus: true, modalVisible: false });
      this.props.getNoticeList();
    }
  };
  componentWillReceiveProps(nextProps) {
    if (this.props.notice != nextProps.notice) {
      this.setState({ readStatus: false });
    }
  }
  render() {
    let { notice, displayWrap = true } = this.props;
    console.log(notice, "notice");

    let { modalVisible, noticeDetails, readStatus } = this.state;
    return (
      <>
        <div className="noticeItem" onClick={this.checkNoticeDetails}>
          {displayWrap && (
            <>
              <Row className="noticeItem_top">
                <Col
                  span={18}
                  className="noticeItem_title"
                  style={{
                    color: !readStatus ? "rgba(0,0,0,.85)" : "rgba(0,0,0,.35)",
                  }}
                >
                  {notice.title}
                </Col>
                <Col span={6} className="noticeItem_flag">
                  {notice.needReplayFlag && !notice.needAnswerFlag && (
                    <span className="receiveTable_icon receiveTable_replayicon ">
                      <img src={ReplayIcon} />
                    </span>
                  )}
                  {notice.attachmentFlag && (
                    <span className="receiveTable_icon receiveTable_clipicon">
                      <img src={AttachmentIcon} />
                    </span>
                  )}
                  {notice.needAnswerFlag && (
                    <span className="receiveTable_icon receiveTable_answericon">
                      <img src={AnswerIcon} />
                    </span>
                  )}
                </Col>
              </Row>
              <Row
                className="noticeItem_bottom"
                style={{
                  color: !readStatus ? "rgba(0,0,0,.45)" : "rgba(0,0,0,.35)",
                }}
              >
                <Col span={12} className="noticeItem_department">
                  {notice.sendOrgName}
                </Col>
                <Col span={12} className="noticeItem_time">
                  {notice.sendTime}
                </Col>
              </Row>
            </>
          )}
          {!displayWrap && (
            <div className="noticeItem_nowrap">
              <div className="noticeItem_nowrap_title">
                <span
                  className="noticeItem_nowrap_title_text"
                  style={{
                    color: !readStatus ? "rgba(0,0,0,.85)" : "rgba(0,0,0,.35)",
                  }}
                >
                  {notice.title}
                </span>
                {notice.attachmentFlag && (
                  <Tooltip placement="bottom" title="附件">
                    <span className="receiveTable_icon receiveTable_clipicon">
                      <img src={AttachmentIcon} />
                    </span>
                  </Tooltip>
                )}
                {notice.needAnswerFlag && (
                  <Tooltip placement="bottom" title="需要回复">
                    <span className="receiveTable_icon receiveTable_answericon">
                      <img src={AnswerIcon} />
                    </span>
                  </Tooltip>
                )}
                {notice.needReplayFlag && !notice.needAnswerFlag && (
                  <Tooltip placement="bottom" title="需要确认">
                    <span className="receiveTable_icon receiveTable_replayicon ">
                      <img src={ReplayIcon} />
                    </span>
                  </Tooltip>
                )}
                {notice.needFormFlag && (
                  <Tooltip placement="bottom" title="表单填报">
                    <span className="receiveTable_icon receiveTable_fillform">
                      <img src="https://bs-application-resource.oss-cn-beijing.aliyuncs.com/app/notice/fillform.svg" />
                    </span>
                  </Tooltip>
                )}
              </div>
              <div
                className="noticeItem_nowrap_mes"
                style={{
                  color: !readStatus ? "rgba(0,0,0,.45)" : "rgba(0,0,0,.35)",
                }}
              >
                <span className="noticeItem_nowrap_senduser">
                  {notice.sendUser.departmentName}-{notice.sendUser.fullName}
                </span>
                <span>{notice.sendTime}</span>
              </div>
            </div>
          )}
        </div>
        {/* <NoticeDetailsModal
                    noticeDetails={noticeDetails}
                    visible={modalVisible}
                    onCancel={() => {this.setState({modalVisible: false})}}
                    readCallback = {this.readCallback}
                    readBtnStatus = {this.state.readBtnStatus}
                    answerCallback = {this.answerCallback}
                ></NoticeDetailsModal> */}
        {!!modalVisible && (
          <DetailModal
            noticeId={notice?.noticeId}
            visible={modalVisible}
            onCancel={() => {
              this.setState({ modalVisible: false });
            }}
            refresh={() => {}}
          />
        )}
      </>
    );
  }
}
